export class Filters {
  constructor(obj) {
    this.departmentsId = obj?.departmentsId || []
    this.dissertationDegreeId = obj?.dissertationDegreeId || null
    this.employeeId = obj?.employeeId || null
    this.excludedType = obj?.excludedType || []
    this.periodId = obj?.periodId || null
    this.searchString = obj?.searchString || null
    this.specialityId = obj?.specialityId || null
    this.statusId = obj?.statusId || null
    this.workTypeId = obj?.workTypeId || []
    this.yearId = obj?.yearId || null
    this.isEffContract = obj?.isEffContract ?? null
  }

  setExcludedType(typesArray) {
    this.excludedType = typesArray
  }

  getForAPI() {
    return {
      departmentsId: this.departmentsId,
      dissertationDegreeId: this.dissertationDegreeId || null,
      employeeId: this.employeeId || null,
      excludedType: this.excludedType,
      periodId: this.periodId || null,
      searchString: this.searchString || null,
      specialityId: this.specialityId || null,
      statusId: this.statusId || null,
      workTypeId: this.workTypeId,
      yearId: this.yearId || null,
      isEffContract: this.isEffContract?.value ?? null
    }
  }
}

export class DynamicFilters {
  constructor(obj) {
    this.acceptanceDates = obj?.acceptanceDates || []
    this.departmentIds = obj?.departmentIds || []
    this.magazineIds = obj?.magazineIds || []
    this.periodIds = obj?.periodIds || []
    this.roleIds = obj?.roleIds || []
    this.statusIds = obj?.statusIds || []
  }

  getForAPI() {
    return {
      acceptanceDates: this.acceptanceDates || [],
      departmentIds: this.departmentIds || [],
      magazineIds: this.magazineIds || [],
      periodIds: this.periodIds || [],
      roleIds: this.roleIds || [],
      statusIds: this.statusIds || []
    }
  }

  static buildFilters(obj) {
    return {
      acceptanceDates: obj?.acceptanceDate ? [obj?.acceptanceDate] : [],
      departmentIds: obj?.departmentId ? [obj?.departmentId] : [],
      magazineIds: obj?.magazineId ? [obj?.magazineId] : [],
      periodIds: obj?.periodId ? [obj?.periodId] : [],
      roleIds: obj?.roleId ? [obj?.roleId] : [],
      statusIds: obj?.statusId ? [obj?.statusId] : []
    }
  }
}
